/**
 * Turns a scraped episode payload into the shape the Add Episode wizard
 * keeps in redux.
 *
 * Lifted out of the getTvSeasonEpisodeMediaData endpoint unchanged so
 * the queued flow can reuse it: a queued scrape produces exactly the
 * same payload, just read back from a finished job later instead of
 * awaited on the spot, and it has to land in redux identically or every
 * step after it would need to know which flow it came from.
 *
 * `referenceData` is the dropdown lists that arrive alongside the
 * scrape (qualities, formats, sources, languages).
 */
export const buildEpisodeData = (
  scrapedEpisodeData: any,
  referenceData: any,
) => {
  const generalTvShowSeasonEpisodeData = {
    title: scrapedEpisodeData.title,
    originalTitle: scrapedEpisodeData.originalTitle,
    itunesTitle: scrapedEpisodeData.itunesTitle,
    number: scrapedEpisodeData.number,
    code: scrapedEpisodeData.code,
    shortDescription: scrapedEpisodeData.shortDescription,
    description: scrapedEpisodeData.description,
    releaseDate: scrapedEpisodeData.releaseDate,
    itunesId: scrapedEpisodeData.itunesId,
    imdbId: scrapedEpisodeData.imdbId,
    imdbRating: scrapedEpisodeData.imdbRating,
    quality: scrapedEpisodeData.quality,
    format: scrapedEpisodeData.format,
    source: scrapedEpisodeData.source,
    sourceLink: scrapedEpisodeData.sourceLink,
    trailerUrl: scrapedEpisodeData.trailerUrl,
  };

  const castCrewTvShowSeasonEpisodeData = {
    cast: scrapedEpisodeData.cast,
    directors: scrapedEpisodeData.directors,
    producers: scrapedEpisodeData.producers,
    screenwriters: scrapedEpisodeData.screenwriters,
  };

  const languageData = scrapedEpisodeData.languages.map((languageItem: any) => {
    return {
      language: {
        id: languageItem.id,
        label: languageItem.label,
      },
      main: languageItem.main,
      audioTrack: false,
      subtitle: false,
    };
  });

  const languagesTvShowSeasonEpisodeData = {
    languages: languageData,
  };

  return {
    generalTvShowSeasonEpisodeData: generalTvShowSeasonEpisodeData,
    castCrewTvShowSeasonEpisodeData: castCrewTvShowSeasonEpisodeData,
    languagesTvShowSeasonEpisodeData: languagesTvShowSeasonEpisodeData,
    qualities: referenceData.qualities,
    formats: referenceData.formats,
    sources: referenceData.sources,
    languages: referenceData.languages,
  };
};
